import React, { useState, useEffect, useMemo, useRef } from "react";
import ProductService from "api/precision/ProductService";
import { Dropdown } from 'react-bootstrap';
import { appConstant } from "config/constant";
import 'styles/scora.css';

export default function Products(props) {
  document.title = 'SCORA Canoe Numbers';

  const { addToCart, cartItems } = props.useShoppingCart();
  const { navigate, location } = props.useRouter();
  const canvasWhiteBg = useRef(null);
  const canvasBlackBg = useRef(null);

  const [canoeNumberWhite, setCanoeNumberWhite] = useState("");
  const [canoeNumberBlack, setCanoeNumberBlack] = useState("");
  const [canoeNumberWhiteQnty, setCanoeNumberWhiteQnty] = useState(0);
  const [canoeNumberBlackQnty, setCanoeNumberBlackQnty] = useState(0);

  useEffect(() => {
    drawWhiteSticker("");
    drawBlackSticker("");
  }, []);

  const drawWhiteSticker = (number) => {
    const ctx = canvasWhiteBg.current.getContext('2d');

    ctx.textAlign = "center";
    let canvas = ctx.canvas;
    let centerX = canvas.width / 2;
    let centerY = canvas.height / 2;
    let radius = Math.min(canvas.width, canvas.height) / 2 - 2;

    // Clear previous drawing
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw white circle background
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
    ctx.fillStyle = "#FFFFFF";
    ctx.fill();
    ctx.closePath();

    // Draw border
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
    ctx.lineWidth = 2; // Adjust border thickness as needed
    ctx.strokeStyle = "#000000"; // Black border
    ctx.stroke();
    ctx.closePath();

    // Dynamically scale font size to fit the circle
    let fontSize = radius * 1.2; // Start with a large font size
    ctx.font = `bold ${fontSize}px NewOrderBold`;
    let textWidth = ctx.measureText(number).width;

    // Reduce font size until text fits within 80% of the circle's diameter
    while (textWidth > radius * 1.8 && fontSize > 10) {
      fontSize -= 2;
      ctx.font = `bold ${fontSize}px NewOrderBold`;
      textWidth = ctx.measureText(number).width;
    }
    
    // Draw the canoe number at the center
    ctx.textBaseline = "middle"; // Center the text vertically
    ctx.fillStyle = "#000000"; // Black text
    ctx.fillText(number, centerX, centerY + 7); // Adjust vertical position as needed

  }

  const drawBlackSticker = (number) => {
    const ctx = canvasBlackBg.current.getContext('2d');
    ctx.textAlign = "center";
    ctx.font = "20px Arsenal";
    let canvas = ctx.canvas;

    let centerX = canvas.width / 2;
    let centerY = canvas.height / 2;
    let radius = Math.min(canvas.width, canvas.height) / 2;

    // Clear previous drawing
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw white circle background
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
    ctx.fillStyle = "#000000";
    ctx.fill();
    ctx.closePath();

    // Dynamically scale font size to fit the circle
    let fontSize = radius * 1.2; // Start with a large font size
    ctx.font = `bold ${fontSize}px NewOrderBold`;
    let textWidth = ctx.measureText(number).width;

    // Reduce font size until text fits within 90% of the circle's diameter
    while (textWidth > radius * 1.8 && fontSize > 10) {
      fontSize -= 2;
      ctx.font = `bold ${fontSize}px NewOrderBold`;
      textWidth = ctx.measureText(number).width;
    }

    ctx.textBaseline = "middle"; // Center the text vertically
    ctx.fillStyle = "#FFFFFF"; // Black text
    ctx.fillText(number, centerX, centerY + 7); // Adjust vertical position as needed

  }

  const handleWhiteStickerkNumber = (ev) => {
    const value = ev.target.value;
    drawWhiteSticker(value);
    setCanoeNumberBlack(parseInt(value));
  }

  const handleWhiteNumberChange = (ev) => {
    const value = ev.target.value;
    setCanoeNumberWhite(parseInt(value));
    drawBlackSticker(value);
  }

  const getUnitPrice = (qnty) => {
    switch (parseInt(qnty)) {
      case 4: case 5: case 6: case 7:
        return 57.28;
      case 8: case 9: case 10: case 11:
        return 30.52;
      case 12: case 13: case 14: case 15:
        return 21.60;
      case 16: case 17: case 18: case 19:
        return 17.14;
      case 20: case 21: case 22: case 23:
        return 14.46;
      case 24: case 25: case 26: case 27:
        return 12.17;
      case 28: case 29: case 30: case 31:
        return 10.96;
      case 32:
        return 10.96;
      default:
        return 10.96;
    }
  }

  const addBlackSticker = () => {
    let ok = true;

    if (canoeNumberWhite < 1 || canoeNumberWhite > 9999) {
      document.getElementById("canoeNumberWhite").classList.add("is-invalid");
      ok = false;
    }
    else {
      document.getElementById("canoeNumberWhite").classList.replace("is-invalid", "is-valid");
    }
    if (canoeNumberBlackQnty < 4) {
      document.getElementById("canoeNumberBlackQnty").classList.add("is-invalid");
      ok = false;
    }
    else {
      document.getElementById("canoeNumberBlackQnty").classList.replace("is-invalid", "is-valid");
    }
    if (!ok) {
      return;
    }

    const item = {
      "id": cartItems.length + 1,
      "product": "blackSticker",
      "quantity": canoeNumberBlackQnty,
      "canoeNumber": canoeNumberWhite
    };
    addToCart(item);
  }

  const addWhiteSticker = () => {

    let ok = true;
    if ((canoeNumberBlack < 1 || canoeNumberBlack > 9999)) {
      document.getElementById("canoeNumberBlack").classList.add("is-invalid");
      ok = false;
    }
    else {
      document.getElementById("canoeNumberBlack").classList.replace("is-invalid", "is-valid");
    }
    if (canoeNumberWhiteQnty < 4) {
      document.getElementById("canoeNumberWhiteQnty").classList.add("is-invalid");
      ok = false;
    }
    else {
      document.getElementById("canoeNumberWhiteQnty").classList.replace("is-invalid", "is-valid");
    }
    if (!ok) {
      return;
    }


    const item = {
      "id": cartItems.length + 1,
      "product": "whiteSticker",
      "quantity": canoeNumberWhiteQnty,
      "canoeNumber": canoeNumberBlack
    };
    addToCart(item);
  }

  const lastCanoeNumber = useMemo(() => {
    const lastItem = cartItems[cartItems.length - 1] ?? null;
    if (lastItem) {
      return lastItem.canoeNumber;
    }
    return null;
  });

  return (
    <div className="">
      <section className="hero_section">
        <div className="mx-md-auto">
          <h1 style={{ width: '875px'}}>Canoe Number Orders</h1>
        </div>
      </section>
      <section className="d-flex flex-column p-3">
        <div className="col-12 text-left px-3 mx-auto mt-2" style={{ maxWidth: '875px' }}>
          <h2 className="text-black fs-4 fst-normal fw-bold">Customize Your Canoe with Official SCORA Numbers</h2>
          <p className="text-secondary fs-4 fw-medium">
            Ensure your outrigger canoe is race-ready with offical SCORA-approved canoe numbers, proudly produced
            in partnership with Precision Services Group (PSG). Our durable, high-visibility numbers are designed for
            easy application and full compliance with SCORA's race regulations. Choose your number style, place your
            order, and get ready to hit the water with confidence.
          </p>
        </div>

        <div className="col-12 text-left px-3 d-flex flex-column flex-md-row align-items-center justify-content-around">
          <div className="" style={{ width: '250px' }}>
            <div className="text-center">
              <canvas ref={canvasWhiteBg} id="canvasWhiteBg" width="175" height="206" style={{ fontFamily: "NewOrderBold" }}></canvas>
            </div>
            <h2 className="text-black fw-bold fst-normal">
              White Background/<br />
              Black Letters
            </h2>
            <h2 className="fw-bold fst-normal" style={{ color: '#8e870a' }}>Starting at $58/ea</h2>
            <div className="fs-4 text-body-secondary fw-medium">In stock</div>
            <div className="fs-4 text-body-secondary fw-medium">Enter Canoe Number:</div>
            <div className="my-3" style={{ width: '100px' }}>
              <input type="number" id="canoeNumberBlack" value={canoeNumberBlack} className="form-control rounded-0 border-secondary-subtle fw-medium fs-5"
                min="4" max="9999" onChange={handleWhiteStickerkNumber}  />
            </div>
            <div>
              <select className="form-control rounded-0 border-secondary-subtle fs-5 text-body-secondary fw-medium" name="canoeNumberWhiteQnty" id="canoeNumberWhiteQnty"
                style={{ width: '280px' }} value={canoeNumberWhiteQnty} onChange={(ev) => setCanoeNumberWhiteQnty(ev.target.value)}>
                <option value=""> Choose Quantity </option>
                <option value="4">QTY 4 | $57.28/ea | $229.12 Total</option>
                <option value="8">QTY 8 | $30.52/ea | $244.14 Total</option>
                <option value="12">QTY 12 | $21.60/ea | $259.15 Total</option>
                <option value="16">QTY 16 | $17.14/ea | $274.17 Total</option>
                <option value="20">QTY 20 | $14.46/ea | $289.18 Total</option>
                <option value="24">QTY 24 | $12.17/ea | $291.97 Total</option>
                <option value="28">QTY 28 | $10.96/ea | $306.88 Total</option>
                <option value="32">QTY 32 | $10.96/ea | $350.72 Total</option>
              </select>
            </div>
            <div className="my-4">
              <button type="button" className="scoraBtn rounded-5 py-2 px-4" onClick={addWhiteSticker}
                >ADD TO CART</button>
            </div>
          </div>

          <div className="" style={{ width: '250px' }}>
            <div className="text-center">
              <canvas ref={canvasBlackBg} id="canvasBlackBg" width="175" height="206"></canvas>
            </div>
            <h2 className="text-black fw-bold fst-normal">
              Black Background/<br />
              White Letters
            </h2>
            <h2 className="fw-bold fst-normal" style={{ color: '#8e870a' }}>Starting at $58/ea</h2>
            <div className="fs-4 text-body-secondary fw-medium">In stock</div>
            <div className="fs-4 text-body-secondary fw-medium">Enter Canoe Number:</div>
            <div className="my-3" style={{ width: '100px' }}>
              <input type="number" id="canoeNumberWhite" value={canoeNumberWhite} className="form-control rounded-0 border-secondary-subtle fw-medium fs-5"
                min="4" max="9999" onChange={handleWhiteNumberChange} />
            </div>
            <div>
              <select className="form-control rounded-0 border-secondary-subtle fs-5 text-body-secondary fw-medium" name="canoeNumberBlackQnty"
                style={{ width: '280px' }} id="canoeNumberBlackQnty" value={canoeNumberBlackQnty} onChange={(ev) => setCanoeNumberBlackQnty(ev.target.value)}>
                <option value=""> Choose Quantity </option>
                <option value="4">QTY 4 | $57.28/ea | $229.12 Total</option>
                <option value="8">QTY 8 | $30.52/ea | $244.16 Total</option>
                <option value="12">QTY 12 | $21.60/ea | $259.20 Total</option>
                <option value="16">QTY 16 | $17.14/ea | $274.24 Total</option>
                <option value="20">QTY 20 | $14.46/ea | $289.20 Total</option>
                <option value="24">QTY 24 | $12.17/ea | $292.08 Total</option>
                <option value="28">QTY 28 | $10.96/ea | $306.88 Total</option>
                <option value="32">QTY 32 | $10.96/ea | $350.72 Total</option>
              </select>
            </div>
            <div className="my-4">
              <button type="button" className="scoraBtn rounded-5 py-2 px-4"
                onClick={addBlackSticker}>ADD TO CART</button>
            </div>
          </div>
        </div>

        <section id="cartMessage" className={`d-flex flex-column mt-4 mb-4 mx-auto toast-transition ${lastCanoeNumber ? " show" : ""}`}
          style={{ backgroundColor: '#f6f5f8', borderTop: 'solid #8fae1b 2px', padding: '20px 40px', maxWidth: '700px', minWidth: '375px' }}>
          <div className="mb-3 fs-5 text-body-secondary fw-medium">
            "Canoe Numbers {lastCanoeNumber}" has been added to your cart.
          </div>
          <div className="d-flex justify-content-end">
            <button type="button" className="border-0 rounded-1 py-1 px-3 fw-bold"
              style={{ backgroundColor: '#e7e6eb', color: '#515151' }} onClick={() => navigate("/scora/cart")}
            >Checkout</button>
          </div>
        </section>

      </section>
    </div>
  );
}